<script>
  import ArrowRight from '@/assets/arrow-right.svg';

  export default {
    components: {
      ArrowRight,
    },

    computed: {
      infos () {
        return [
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam non enim sollicitudin, tincidunt diam dignissim, ultrices risus. Cras varius tortor sed blandit viverra.',
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam non enim sollicitudin.',
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam non enim sollicitudin.',
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        ];
      },
    },
  };
</script>

<template>
  <article class="transaction-info card">
    <header class="card__header">
      <h3 class="card__title">Informações e Análises</h3>
    </header>

    <ul class="transaction-info__list">
      <li
        :key="index"
        class="transaction-info__item"
        v-for="(item, index) in infos"
        >
        <a class="transaction-info__link" href="https://google.com.br" target="_blank">
          <span
            v-text="item"
            >
          </span>

          <ArrowRight />
        </a>
      </li>
    </ul>
  </article>
</template>

<style lang="scss">
  .transaction-info {
    // @todo drop fixed height?
    height: 582px;

    &__list {
      padding: 0 24px;
    }

    &__item {
      &:not(:last-child) {
        border-bottom: 1px solid rgba(147, 156, 172, 0.26);
      }
    }

    &__link {
      display: flex;
      padding: 24px 0;
      align-items: center;
      letter-spacing: 0.32px;
      color: rgba(#FFF, .8);

      span {
        flex: 1;
        line-height: 1.5;
      }

      svg {
        margin-left: 16px;
      }
    }
  }
</style>
